import ChairLamp from '../src/ChairLamp';
export default ChairLamp;
